import React from 'react';
import PropTypes from 'prop-types';
import { BetPromo } from '../BetPromo';
import PlayItv from '../CallToActions/PlayItv';
import PrizeDrawCard from '../PrizeDrawCard';
import { RunnerCard } from '../RunnerCard';
import * as Styled from './styles';

const ResultedState = ({
    title,
    eventName,
    winningHorsesData,
    TermsLink,
    Itv7TermsLink,
    prize,
    ButtonLink,
    bettingEnabled,
    promotionsConfig
}) => {
    return (
        <Styled.ContentWrapper>
            <Styled.Title>{title} SWEEPSTAKE</Styled.Title>
            <Styled.SubTitle>
                {eventName} Winner{winningHorsesData.length > 1 ? 's' : ''}
            </Styled.SubTitle>
            {winningHorsesData.map(runnerCardData => (
                <Styled.RunnerCardWrapper key={runnerCardData.clothNumber}>
                    <RunnerCard
                        clothNumber={runnerCardData.clothNumber}
                        horseName={runnerCardData.horseName}
                        jockeyName={runnerCardData.jockeyName}
                        trainerName={runnerCardData.trainerName}
                        silk={runnerCardData.silk}
                    />
                </Styled.RunnerCardWrapper>
            ))}
            <PrizeDrawCard
                eventName={eventName}
                TermsLink={TermsLink}
                xLink="https://x.com/ITV7Racing"
                hadEntry={false}
                didEntryWin={false}
                prize={prize}
            />
            <Styled.PlayItvWrapper>
                <PlayItv
                    titleText={`MISSED OUT ON THE ${title} SWEEPSTAKE?`}
                    buttonText="PLAY ITV7"
                    TermsLink={Itv7TermsLink}
                    ButtonLink={ButtonLink}
                />
            </Styled.PlayItvWrapper>
            {bettingEnabled && (
                <Styled.BetPromoWrapper>
                    <BetPromo promotionsConfig={promotionsConfig} />
                </Styled.BetPromoWrapper>
            )}
        </Styled.ContentWrapper>
    );
};

ResultedState.propTypes = {
    title: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    prize: PropTypes.string.isRequired,
    winningHorsesData: PropTypes.arrayOf(
        PropTypes.shape({
            clothNumber: PropTypes.string,
            horseName: PropTypes.string,
            jockeyName: PropTypes.string,
            trainerName: PropTypes.string,
            silk: PropTypes.string
        })
    ).isRequired,
    ButtonLink: PropTypes.func.isRequired,
    TermsLink: PropTypes.func.isRequired,
    Itv7TermsLink: PropTypes.func.isRequired,
    bettingEnabled: PropTypes.bool.isRequired,
    promotionsConfig: PropTypes.shape({
        enabled: PropTypes.bool,
        href: PropTypes.string,
        img: PropTypes.shape({
            mobile: PropTypes.string,
            desktop: PropTypes.string
        })
    }).isRequired
};

export default ResultedState;
